import React, { useEffect, useState, useCallback } from 'react';
import Modal from "react-bootstrap/Modal";
import { useTranslation } from 'react-i18next';
import LeaseApiService from '../../services/apiService';

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

const ImagesList = ({ attachments, setDeletedFiles, deletedFiles, setAttachments, createEmptyRow, readOnly = false }) => {
    const { t } = useTranslation();
    const apiService = new LeaseApiService();

    // Attachment
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    // Attachment Functions
    const handleFileSelect = useCallback((file, id) => {
        setAttachments((prev) => {
            const updated = prev.map((row) =>
                row.id === id
                    ? {
                        ...row,
                        file,
                        fileName: file.name,
                        isNew: true,   // ✅ mark new
                    }
                    : row
            );

            return [...updated, createEmptyRow()];
        });
    }, []);
    const handleRemarkChange = (id, value) => {
        setAttachments((prev) =>
            prev.map((row) =>
                row.id === id ? { ...row, remarks: value } : row
            )
        );
    };
    const handleDelete = async (row) => {
        if (!row.isNew) {
            setDeletedFiles((prev) => [...prev, row.fileName]);
            const fileparams = new URLSearchParams();
            fileparams.append('filePath', row?.filePath);
            const imgRes = await apiService.deleteParameter('DELETE_FILE', `?${fileparams.toString()}`);
        }

        setAttachments((prev) => prev.filter((item) => item.id !== row.id));
    };
    const handleView = (row) => {
        if (!row) return;

        if (row.isNew) {
            setPreviewImage(URL.createObjectURL(row.file));
        } else {
            setPreviewImage(row.fullUrl);
        }

        setPreviewModal(true);
    };

    return (
        <div className=''>
            <table className="table table-bordered">
                <thead className="dynoTable">
                    <tr>
                        <th>{t('common.fileName')}</th>
                        <th>{t('common.remarks')}</th>
                        {!readOnly && <th>{t('common.upload')}</th>}
                        <th>{t('common.view')}</th>
                        {!readOnly && <th>{t('common.delete')}</th>}
                    </tr>
                </thead>
                <tbody>
                    {attachments.map((row) => (
                        <tr key={row.id}>
                            <td>
                                <input disabled value={row.fileName} className="form-control" />
                            </td>

                            <td>
                                <input
                                    disabled={readOnly}
                                    value={row.remarks}
                                    className="form-control"
                                    onChange={(e) =>
                                        handleRemarkChange(row.id, e.target.value)
                                    }
                                />
                            </td>

                            {!readOnly && (
                            <td>
                                <input
                                    type="file"
                                    hidden
                                    id={`file-${row.id}`}
                                    onChange={(e) =>
                                        handleFileSelect(e.target.files[0], row.id)
                                    }
                                />
                                <button
                                    className="mainbtn"
                                    onClick={() =>
                                        document.getElementById(`file-${row.id}`).click()
                                    }
                                >
                                    {t('common.upload')}
                                </button>
                            </td>
                            )}

                            <td>
                                <button
                                    className="mainbtnRed"
                                    disabled={!row.fileName}
                                    onClick={() => handleView(row)}
                                >
                                    {t('common.view')}
                                </button>
                            </td>

                            {!readOnly && (
                            <td>
                                <button
                                    className="mainbtnSecondary"
                                    onClick={() => handleDelete(row)}
                                >
                                    {t('common.delete')}
                                </button>
                            </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
            <Modal show={previewModal} size="lg" onHide={() => setPreviewModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('common.preview')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {previewImage && (
                        <img
                            src={previewImage}
                            alt="preview"
                            style={{ width: "100%" }}
                        />
                    )}
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default ImagesList